import { IUpdatePatrimonioCentroCustoUseCase } from "../../../presentation/useCases/update/update_patrimonio_centro_custo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdatePatrimonioCentroCustoUseCase
 */

export class UpdatePatrimonioCentroCustoUseCase implements IUpdatePatrimonioCentroCustoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updatePatrimonioCentroCusto(
    idPatrimonioCentroCusto: number,
    idCentroCusto?: number | null,
    status?: number | null,
  ): Promise<void> {
    await this.repository.updatePatrimonioCentroCusto(
      idPatrimonioCentroCusto,
      idCentroCusto,
      status,
    );
  }
}
